import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfirmationComponent } from './confirmation.component';

export interface ComponentCanDeactivate {
  canDeactivate(): boolean | Observable<boolean>;
}

export const CanDeactivateState = {
  defendAgainstBrowserBackButton: false,
};

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard {
  constructor(private matDialog: MatDialog) {}

  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    // First check the component's own logic for deactivation
    const canDeactivate = component.canDeactivate();
    // if (typeof canDeactivate === 'boolean') {
    //   // If the component returns a boolean, no dialog is needed
    //   return canDeactivate;
    // }

    // If the component returns an Observable, show the confirmation dialog
    return canDeactivate || this.matDialog
      .open(ConfirmationComponent, {
        disableClose: true,
      })
      .afterClosed()
      .pipe(
        tap((confirmed) => {
          if (!confirmed && CanDeactivateState.defendAgainstBrowserBackButton) {
            // Prevent browser back button action
            history.pushState(null, '', '');
          }
        })
      );
  }
}
